import React from "react";
import { heroContent } from "../mock";
import useReveal from "../hooks/useReveal";

const renderRich = (parts) =>
  parts.map((p, i) =>
    p.bold ? (
      <strong key={i} className="font-semibold text-[#16182C]">
        {p.text}
      </strong>
    ) : (
      <span key={i}>{p.text}</span>
    )
  );

const Hero = () => {
  const ref = useReveal();
  return (
    <section className="bg-white">
      <div className="max-w-7xl mx-auto px-5 md:px-8 py-16 md:py-24">
        <div ref={ref} className="reveal grid md:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative">
            <div className="overflow-hidden rounded-md shadow-lg group">
              <img
                src={heroContent.truckImage}
                alt="Furgone Spedy Fly per spedizioni"
                className="w-full h-[280px] md:h-[360px] object-cover transition-transform duration-700 group-hover:scale-105"
              />
            </div>
            <div className="absolute -bottom-3 -left-3 w-24 h-24 rounded-md bg-[#E23028]/10 -z-0 hidden md:block" />
          </div>

          <div>
            <h1 className="heading-navy font-bold text-4xl md:text-5xl leading-[1.1] tracking-tight">
              {heroContent.title}
            </h1>
            <div className="mt-6 space-y-5 text-[#5a5a66] text-[16px] leading-relaxed">
              {heroContent.paragraphs.map((para, i) => (
                <p key={i}>{renderRich(para)}</p>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
